import { Col, Row } from "react-bootstrap";

export function OrderReceipt({
  children,
  delivery,
  flatOnMobile = false,
  targetRef,
  id,
}) {
  return (
    <div
      ref={targetRef}
      id={id}
      tabIndex={targetRef ? -1 : undefined}
      className={`receipt-shell${
        flatOnMobile ? " receipt-shell--flat-mobile" : ""
      }`}
    >
      <div className="receipt-paper">
        <div className="receipt-heading">
          <span>Zamówienie</span>
          <h5>Twój koszyk</h5>
        </div>
        {delivery && <div className="receipt-delivery">{delivery}</div>}
        <div className="receipt-cart">{children}</div>
        <div className="receipt-footer">Eatally · zamów online</div>
      </div>
    </div>
  );
}

function OrderingLayout({ header, children, receipt }) {
  return (
    <div className="ordering-surface">
      <Row className="g-0 selected-day-pass">
        <Col lg="8" className="menu-column">
          <div className="selected-day-menu">{header}</div>
          {children}
        </Col>
        <Col lg="4" className="order-sidebar">
          <div className="selected-day-cart" aria-hidden="true" />
          {receipt}
        </Col>
      </Row>
    </div>
  );
}

export default OrderingLayout;
